module.exports = "//cdn.mxpnl.com/static/asset-cache/b7936ae7c7a1701e8a83914e56068caa/iron/common/assets/images/query/formula.svg";